import React from 'react';

/**
 * Split text renderer. Each visible character becomes a span so the
 * Reveal wrapper (or any parent animation) can stagger them individually.
 *
 * Usage:
 *   <SplitText text="Bimarsh Jha" stagger={45} />
 */
export const SplitText = ({ text, stagger = 40, className = '', startDelay = 0 }) => {
  const characters = Array.from(text);

  return (
    <span className={`split-text ${className}`} aria-label={text}>
      {characters.map((ch, i) => {
        const isSpace = ch === ' ';
        return (
          <span
            key={`${ch}-${i}`}
            className={`split-char${isSpace ? ' split-char-space' : ''}`}
            style={{ animationDelay: `${startDelay + i * stagger}ms` }}
            aria-hidden="true"
          >
            {isSpace ? '\u00A0' : ch}
          </span>
        );
      })}
    </span>
  );
};
